import { usePlanStore } from './plan'
import type { CartItemAndLineItem } from '@/mixins/merchandise'
import { useMerchandise } from '@/mixins/merchandise'
import type { CustomCartItem } from '@/types'
import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export type Cart = {
	cartItems: CartItemAndLineItem[]
	customCartItems: CustomCartItem[]
	includesFreeEverplansPremium: boolean
}

export const useCartStore = defineStore('cart', () => {
	const cart = ref<Record<string, Cart>>({})
	const planStore = usePlanStore()
	const { getPlanCartItems, shouldIncludeFreeEverplansPremium } =
		useMerchandise()

	watch(
		() => planStore.plans.map((plan) => plan.cartItems),
		() => {
			planStore.plans.forEach((plan) => {
				const planCartItems = getPlanCartItems(plan.id) ?? []
				const includesFreeEverplansPremium = shouldIncludeFreeEverplansPremium(
					plan.id
				)

				cart.value[plan.id] = {
					cartItems: planCartItems ?? [],
					customCartItems: plan.customCartItems,
					includesFreeEverplansPremium: !!includesFreeEverplansPremium,
				}
			})
		},
		{ immediate: true, deep: true }
	)

	return {
		cart,
	}
})
